<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded"><span class="epub-i">To my oldest daughter, Amy,</span></p>
<p class="ded"><span class="epub-i">a constant source of</span></p>
<p class="ded"><span class="epub-i">joy and love</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?03775378